import { bffServiceInstance } from "@/plugins/api_service/services";

const prefix = "/management/organizations";

export default {
  search: (query) => bffServiceInstance.get(`${prefix}/`, query),
  store: (formPlan) => bffServiceInstance.post(`${prefix}`, {}, formPlan),
  show: (id) => bffServiceInstance.get(`${prefix}/${id}`),
  update: (id, body) => bffServiceInstance.put(`${prefix}/${id}`, {}, body),
  remove: (id) => bffServiceInstance.delete(`${prefix}/${id}`),
  //get parent organization
  getParentList: (query) =>
    bffServiceInstance.get(`${prefix}/get-select-list`, query),
  getTreeOrganization: (facility_code) =>
    bffServiceInstance.get(`${prefix}`, { facility_code }),
  getOrgsByPrefAndFacilityCode: (
    facility_code,
    facility_organization_pref_code,
    login_organization,
    client = false
  ) => {
    let query = {
      facility_code,
      facility_organization_pref_code,
    };

    if (!client) {
      query.login_organization = login_organization;
    }

    return bffServiceInstance.get(`${prefix}/get-select-list`, query);
  },
  getOrgManageMember: (facility_code, login_organization) => {
    let query = {
      facility_code,
      login_organization,
      manage_member: 1, // only for manage/member
    };
    return bffServiceInstance.get(`${prefix}/get-select-list`, query);
  },

  getOrgClientMember: (facility_code, free_member, screen = "") => {
    let query = {
      facility_code,
      free_member,
      screen,
    };
    return bffServiceInstance.get(`${prefix}/get-select-list`, query);
  },

  getOrganizationByFacility: (facility_code) => {
    return bffServiceInstance.get(`${prefix}/get-select-list`, {
      facility_code,
    });
  },
  getFilterOrgManageMember: (
    facility_code,
    login_organization,
    pref_code = "",
    work_pref_code = ""
  ) => {
    let query = {
      facility_code,
      login_organization,
      pref_code,
      work_pref_code,
      manage_member: 1, // only for manage/member
    };
    return bffServiceInstance.get(`${prefix}/get-select-list`, query);
  },

  getFilterOrgClientMember: (
    facility_code,
    free_member,
    screen = "",
    pref_code = "",
    work_pref_code = ""
  ) => {
    let query = {
      facility_code,
      free_member,
      screen,
      pref_code,
      work_pref_code,
    };
    return bffServiceInstance.get(`${prefix}/get-select-list`, query);
  },
};
